import React, { useState } from 'react';
import { AddUser } from '../utils/usersAPI';
import { Button, TextField, Grid, Typography, Container } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { AppbarContainer, AppbarHeader } from '../styles/headerStyle';


const RegistrationForm = () => {
    //אתחול האובייקט באמצעות useState עם השדות הרלוונטיות להרשמה
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        phone: "",
        city: "",
        street: "",
        houseNumber: "",
        apartment: "",
        floor: "",
        entrance: "",
        notes: ""
    });
    //במקרה של שגיאה
    const [error, setError] = useState('');
    const navigate = useNavigate();//מופע של הפונקציה עם יכולת הניווט

    //פונקציה שתעדכן את השדה המתאים באובייקט כאשר הערכים משתנים
    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({
    //         ...formData,
    //         [name]: value
    //     });
    // };

    // //פונקציה המטפלת בהגשת הטופס וניגשת לכל נתוני רישום המשתמש המאוחסנים באובייקט
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //         await AddUser(formData).then(res => {
    //             console.log(res);
    //             if(res.status === 200){
    //                 alert("נרשמת בהצלחה:)");
    //             }
    //         }).catch((error) =>{
    //         setError('ההרשמה נכשלה, נסה שנית')
    //     })
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // בדיקה שכל השדות מולאו
        if (
            !formData.name ||
            !formData.email ||
            !formData.password ||
            !formData.phone ||
            !formData.city ||
            !formData.street ||
            !formData.houseNumber
        ) {
            setError("חובה למלא שם, מייל, סיסמה, טלפון, עיר, רחוב ומספר בניין");
            return;
        }

        if (formData.password.length < 6) {
            setError('הסיסמה חייבת להכיל לפחות 6 תווים');
            return;
        }



        // בדיקת אימייל
        const emailRegex = /^\S+@\S+\.\S+$/;
        if (!emailRegex.test(formData.email)) {
            setError('כתובת האימייל אינה חוקית');
            return;
        }

        // ✅ רק אם הכל עבר – שולחים לשרת
        try {

            const userToSend = {
                name: formData.name,
                email: formData.email,
                password: formData.password,
                phone: formData.phone,

                userAddresses: [
                    {
                        city: formData.city,
                        street: formData.street,
                        houseNumber: formData.houseNumber,
                        apartment: formData.apartment || null,
                        floor: formData.floor || null,
                        entrance: formData.entrance || null,
                        notes: formData.notes || null,
                        isDefault: true
                    }
                ]
            };

            const res = await AddUser(userToSend);

            if (res.status === 200) {
                alert("נרשמת בהצלחה :)");
                navigate("/");
            }
        }
        catch (err) {
            setError(err.response?.data || "ההרשמה נכשלה, נסה שנית");
        }
    };



    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({ ...prev, [name]: value }));

    };



    return (
        <>
            {/* <AppbarContainer>
                    <AppbarHeader>Welcome to Shine's Stock</AppbarHeader>
                </AppbarContainer> */}
            <Container maxWidth="xs" style={{ marginTop: '140px' }}></Container>
            <Container maxWidth="xs" style={{ marginTop: '140px' }}>
                <Typography variant="h4" align="center" gutterBottom>
                    רישום משתמש חדש
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label="שם מתשמש"
                                name="name"
                                fullWidth
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        {/* מספר טלפון */}
                        <Grid item xs={12}>
                            <TextField
                                label="מספר טלפון"
                                name="phone"
                                type="tel"
                                fullWidth
                                value={formData.phone}
                                onChange={handleInputChange}
                            />
                        </Grid>


                        <Grid item xs={12}>
                            <TextField
                                label="כתובת מייל"
                                name="email"
                                type="email"
                                fullWidth
                                value={formData.email}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="סיסמה"
                                name="password"
                                type="password"
                                fullWidth
                                value={formData.password}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        {/* כתובת למשלוח */}
                        {/* כתובת למשלוח */}
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                כתובת למשלוח
                            </Typography>

                            <TextField
                                label="עיר"
                                name="city"
                                fullWidth
                                value={formData.city}
                                onChange={handleInputChange}
                                sx={{ mb: 2 }}
                            />

                            <TextField
                                label="רחוב"
                                name="street"
                                fullWidth
                                value={formData.street}
                                onChange={handleInputChange}
                                sx={{ mb: 2 }}
                            />

                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                <Grid item xs={6}>
                                    <TextField
                                        label="מספר בניין"
                                        name="houseNumber"
                                        fullWidth
                                        value={formData.houseNumber}
                                        onChange={handleInputChange}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        label="דירה (אופציונלי)"
                                        name="apartment"
                                        fullWidth
                                        value={formData.apartment}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                <Grid item xs={6}>
                                    <TextField
                                        label="קומה (אופציונלי)"
                                        name="floor"
                                        fullWidth
                                        value={formData.floor}
                                        onChange={handleInputChange}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        label="כניסה (אופציונלי)"
                                        name="entrance"
                                        fullWidth
                                        value={formData.entrance}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                            </Grid>

                            <TextField
                                label="הערות לשליח (אופציונלי)"
                                name="notes"
                                fullWidth
                                multiline
                                rows={3}
                                value={formData.notes}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        {error && <span>{error}</span>}
                    </Grid>
                    <Button type="submit" variant="contained" color="primary" fullWidth >
                        הרשמה
                    </Button>
                </form>
            </Container>
        </>
    );
};

export default RegistrationForm;